import {
  type Client,
  CloseCode,
  createClient as createGraphqlWsClient,
} from 'graphql-ws';
import getToken from '@/utils/getToken';

const retryBlockedCloseCodes = new Set<number>([
  CloseCode.InternalServerError,
  CloseCode.InternalClientError,
  CloseCode.BadRequest,
  CloseCode.BadResponse,
  CloseCode.Unauthorized,
  CloseCode.Forbidden,
  CloseCode.SubprotocolNotAcceptable,
  CloseCode.SubscriberAlreadyExists,
  CloseCode.TooManyInitialisationRequests,
]);

function getCloseCode(event: unknown) {
  if (typeof event !== 'object' || event === null) {
    return null;
  }

  if (!('code' in event)) {
    return null;
  }

  const value = event.code;
  return typeof value === 'number' ? value : null;
}

function isRetryableClose(event: unknown) {
  const code = getCloseCode(event);

  if (code === null) {
    return true;
  }

  return !retryBlockedCloseCodes.has(code);
}

export function createUrqlWsClient(): Client {
  if (!process.env.EXPO_PUBLIC_GRAPHQL_WS_URL) {
    throw new Error(
      'EXPO_PUBLIC_GRAPHQL_WS_URL must be defined to create a new urql ws client.',
    );
  }
  return createGraphqlWsClient({
    url: process.env.EXPO_PUBLIC_GRAPHQL_WS_URL,
    lazy: true,
    keepAlive: 15_000,
    retryAttempts: Number.POSITIVE_INFINITY,
    shouldRetry: isRetryableClose,
    async connectionParams() {
      const token = await getToken(true);

      if (token) {
        return {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      }
      return {};
    },
  });
}
